import { Routes } from '@angular/router';
import { internalRoutes } from './app/layouts/internal/internal.routes';
import { externalRoutes } from './app/layouts/external/external.routes';
import { customerAreaRoutes } from './app/layouts/customer-area/customer-area.routes';
export const routes: Routes = [
  ...externalRoutes,
  ...internalRoutes,
  ...customerAreaRoutes,

  { path: '**', redirectTo: '/home' },
];
